
<template>
  <svg
    :width="size"
    :height="size" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <g id="coins-10" clip-path="url(#clip0_12604_97364)">
      <path id="Vector" d="M9.00003 2.76061C9.79581 1.9808 10.8857 1.5 12.0879 1.5C14.5246 1.5 16.5 3.47537 16.5 5.91212C16.5 7.11432 16.0192 8.20422 15.2394 9M7.26264 7.80542H7.94351C8.69558 7.80542 9.30526 8.41511 9.30526 9.16719M7.26264 7.80542H6.67904C5.87325 7.80542 5.22002 8.45866 5.22002 9.26446C5.22002 10.0703 5.87325 10.7235 6.67904 10.7235H7.84624C8.65203 10.7235 9.30526 11.3767 9.30526 12.1825C9.30526 12.9883 8.65203 13.6416 7.84624 13.6416H7.26264M7.26264 7.80542V6.93M7.26264 13.6416H6.58177C5.8297 13.6416 5.22002 13.0319 5.22002 12.2798M7.26264 13.6416V14.517M13.5 10.8C13.5 14.2794 10.6794 17.1 7.20002 17.1C3.72063 17.1 0.900024 14.2794 0.900024 10.8C0.900024 7.32061 3.72063 4.5 7.20002 4.5C10.6794 4.5 13.5 7.32061 13.5 10.8Z" :stroke="color" stroke-width="1.6" stroke-linecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_12604_97364">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: string | number;
  color?: string;
}>(), {
  size: 18,
  color: 'currentColor'
});
</script>